/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface DrawerOpenParams {
  experience_id: string;
  tab_key: string;
  trigger_label: string;
}

/**
 * 発火タイミング: 体験詳細ページで施設情報ドロワーが起動リンクから開いた時（開き直すたびに送る）。
 *
 * `tab_key` は**解決後**のタブキー。入稿の tabKey が外れて先頭タブで開いた場合は、実際に開いたタブのキーが入る（D-006）。
 */
export const sendGAWabunkaDrawerOpenEvent = (params: { experienceId: string; tabKey: string; triggerLabel: string }) => {
  sendWabunkaGAEvent('drawer_open', {
    experience_id: params.experienceId,
    tab_key: params.tabKey,
    trigger_label: params.triggerLabel,
  });
};
